// extracted by css-extract-rspack-plugin
export default {"main":"EditMail__main--tGuZ8"};